import styled from 'styled-components/macro';
import { colorCoreBlack300, colorCoreGray1000Base, colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
export const AllProductUnitPricesStyled = styled.div `
  padding: 16px 0;
  margin-top: 24px;
  border-top: 1px solid ${colorCoreGray500};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};
`;
export const StrikethroughTextStyled = styled.s `
  color: ${colorCoreBlack300};
  display: inline-block;
  padding: 0 20px 0 0;
  position: relative;

  &::after {
    content: '';
    width: 3px;
    height: 3px;
    border-radius: ${CORNER_RADIUS.xxs};
    background-color: ${colorCoreGray1000Base};
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translate(0, -50%);
  }
`;
